<template>
  <div class="search-result-box" style="margin-top:1px">
    <tab
      :line-width="1"
      custom-bar-width="60px"
      active-color="#027CFA"
      v-model="tabIndex"
    >
      <tab-item
        :selected="item == selectName"
        @on-item-click="onItemClick"
        v-for="item in tabs"
        :key="item.id"
      >
        {{ item | tabName }}
      </tab-item>
    </tab>
    <div class="scroll_div" ref="scroll_div" @touchmove="preLoad(getPre)">
      <default-page v-if="showDefaultPage"></default-page>
      <component
        v-else
        :is="componentName"
        :need-highlight="true"
        :keys="keyword"
        :list="list"
        style="padding: 0 .4rem"
      ></component>
    </div>
    <p style="text-align:center;margin-top: 1rem" v-show="!list">
      <inline-loading></inline-loading>
      <span style="vertical-align:middle;display:inline-block;font-size:14px;">
        &nbsp;&nbsp;加载中
      </span>
    </p>
  </div>
</template>

<script>
// TODO: vux
import { Spinner, Tab, TabItem } from 'vux';
import { mapState } from 'vuex';
import ListForImgAndText from '@/components/Headline/list.vue';
import ZoneList from '@/components/Zone/ZoneList';
import courseList from '@/components/Course/SmailList.vue';
import Bingli from '@/components/Headline/Bingli.vue';
import { loadMore } from '@/Mixin/loadMore.js';
export default {
  mixins: [loadMore],
  components: {
    Spinner,
    Tab,
    TabItem,
    ListForImgAndText,
    ZoneList,
    courseList,
    Bingli,
    Bingli2: Bingli
  },
  data() {
    return {
      selectName: '',
      list: null, // 数据
      loading: false, //loading动画
      componentName: null, //显示组件
      tabs: null, // tab
      ajaxList: null, // tab对应ajax
      tabIndex: 0, // 当前索引
      params: {
        // 分页
        from: 0,
        pageSize: 20,
        pageNo: 1
      },
      loadFlag: true, // 是否加载
      urls: null, //http 请求
      showSearch: true //是否显示 搜索默认页
    };
  },
  computed: {
    ...mapState({
      keyword: state => state.search.keyword
    })
  },
  methods: {
    moreList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;

        this.$http.post(this.urls, data).then(res => {
          let resp = res.data.data.list;
          if (!this.list.length && !resp.length) {
            this.showDefaultPage = true;
          } else {
            this.showDefaultPage = false;
          }

          for (var i = 0; i < resp.length; i++) {
            this.list.push(resp[i]);
          }
          if (resp.length < 20) {
            this.loadFlag = false;
            return false;
          }
          this.params.pageNo += 1;
          this.loadFlag = true;
        });
      }
    },

    getPre() {
      this.moreList(Object.assign(this.params, { keyword: this.keyword }));
    },
    info(url, component) {
      if (component == 'Bingli') {
        this.params.type = 2;
      } else if (component == 'Bingli2') {
        this.params.type = 1;
      }
      this.params.from = 0;
      this.params.pageNo = 1;
      this.showSearch = false;
      this.list = [];
      this.loadFlag = true;
      this.urls = url;
      this.getPre();
      this.componentName = component;
    },
    //回车 搜索
    onSubmit() {
      if (this.$route.query.type == 2) {
        this.info('/rest/ysh/wx/info/searchContent', 'Bingli2');
      } else {
        this.info('/rest/ysh/wx/course/search', 'courseList');
      }
      this.tabIndex = 0;
    },
    //TABITEM点击
    onItemClick(index) {
      this.info(this.ajaxList[index], this.tabs[index]);
    }
  },
  created() {
    if (this.$route.query.type == 2) {
      this.selectName = 'Bingli2';
      this.ajaxList = [
        '/rest/ysh/wx/info/searchContent',
        '/rest/ysh/wx/info/searchContent'
      ];
      this.tabs = ['Bingli2', 'Bingli'];
    } else {
      this.selectName = 'courseList';
      this.ajaxList = [
        '/rest/ysh/wx/course/search',
        '/rest/ysh/wx/info/topNews',
        '/rest/ysh/wx/channel/channelList'
      ];
      this.tabs = ['courseList', 'ListForImgAndText', 'ZoneList'];
    }
  },
  filters: {
    tabName(v) {
      if (v == 'courseList') {
        return '课程';
      } else if (v == 'ListForImgAndText') {
        return '阅读';
      } else if (v == 'ZoneList') {
        return '专区';
      } else if (v == 'Bingli') {
        return '病例';
      } else if (v == 'Bingli2') {
        return '帖子';
      }
    }
  }
};
</script>
<style lang="less">
// 修改 TabItem 字体与线
.search-result-box {
  .vux-tab-item {
    font-size: 0.4rem;
  }
  .vux-tab-bar-inner {
    width: 1.0667rem !important;
    height: 0.0533rem /* 4/75 */;
  }
  .vux-tab-ink-bar {
    height: 0.0533rem !important;
  }
}
</style>
<style lang="less" scoped></style>
